export default function({ store, redirect, route, app }) {
  const user = store.state.user
  // console.log('middleware auth | user', user)
  // console.log('route.fullPath', route.fullPath)
  // console.log('app', app.i18n.locale)
  if (!user) redirect(`${app.i18n.locale !== 'ru' ? '/' + app.i18n.locale : ''}/signin?ref=${route.fullPath}`)
}
